<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <v-select
      multiple
      dense
      chips
      deletable-chips
      :value="value"
      :items="availableBusinessProcesses"
      :label="label"
      :menu-props="{ contentClass: 'custom-scrollbar' }"
      :item-value="itemValue"
      :item-text="itemText"
      @change="onValueChange"
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @click="selectAll">
          <v-list-item-action>
            <v-icon :color="value.length > 0 ? 'primary' : ''">
              {{ selectAllIcon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('selectAll') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-select>
  </div>
</template>

<script>
import EcsBusinessProcessSelectionMixin from '@/components/ecs-business-process-selection/EcsBusinessProcessSelectionMixin';

export default {
  name: 'EcsBusinessProcessMultipleSelection',
  mixins: [EcsBusinessProcessSelectionMixin],
  computed: {
    selectAllIcon() {
      if (this.value.length === this.availableBusinessProcesses.length) {
        return 'mdi-close-box';
      }
      if (this.value.length === 0) {
        return 'mdi-checkbox-blank-outline';
      }
      return 'mdi-minus-box';
    }
  },

  methods: {
    isItemSelected(item) {
      return this.value.indexOf(item[this.itemValue]) >= 0;
    },

    selectAll() {
      const businessProcesses = [];
      if (this.value.length !== this.availableBusinessProcesses.length) {
        this.availableBusinessProcesses.forEach(item => businessProcesses.push(item[this.itemValue]));
      }
      this.onValueChange(businessProcesses);
    }
  }
};
</script>

<style scoped></style>
